// extracted by mini-css-extract-plugin
module.exports = {"app_container":"App_app_container__3q_K2"};